import { render } from "./FullModal.vue?vue&type=template&id=4658a26e"
import script from "./FullModal.vue?vue&type=script&lang=js"
export * from "./FullModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__